module.exports = __webpack_public_path__ + "shadow-rocksmith-plus.png";